import type { MatchDto } from "@/types/app/MatchDto";
import { Button, Card, CardBody, CardHeader } from "@nextui-org/react";
import { ArrowUp } from "lucide-react";
import { useState } from "react";
import { MatchCard } from "./MatchCard";

type LatestResultsCardProps = {
	matches: MatchDto[];
};

export const LatestResultsCard = ({ matches }: LatestResultsCardProps) => {
	const [isCollapsed, setIsCollapsed] = useState(matches.length === 0);

	return (
		<Card className="w-full md:w-3/4 mx-auto">
			<CardHeader
				className="flex flex-row justify-between cursor-pointer"
				onClick={() => setIsCollapsed(!isCollapsed)}
			>
				<h2 className="text-lg font-semibold uppercase mx-auto">
					Výsledky za poslední týden
				</h2>
				<Button
					isIconOnly
					variant="light"
					size="sm"
					onPress={() => setIsCollapsed(!isCollapsed)}
				>
					<span
						className={`transition-transform duration-300 ease-in-out ${
							isCollapsed ? "rotate-180" : "rotate-0"
						}`}
					>
						<ArrowUp />
					</span>
				</Button>
			</CardHeader>
			<div
				className={`transition-all duration-300 ease-in-out overflow-hidden ${
					isCollapsed ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"
				}`}
			>
				<CardBody className="flex flex-row gap-4 overflow-x-scroll">
					{matches.length > 0 ? (
						matches.map((match) => (
							<MatchCard key={match.id} match={match} type="result" size="sm" />
						))
					) : (
						<p className="text-center uppercase text-semibold ">
							V posledním týdnu nebyly nalezeny žádné výsledky
						</p>
					)}
				</CardBody>
			</div>
		</Card>
	);
};
